import React, { FC } from "react";
import classNames from "classnames";
import { InputNumber as InputNumberAntd, InputNumberProps } from "antd";

import { BemHelper } from "../../utils";

const bem = new BemHelper("input-number-protec");

export type Props = InputNumberProps;

export const InputNumberProtec: FC<Props> = ({ ...props }) => {
  return (
    <div
      className={classNames([
        bem.block(),
        props.addonBefore && bem.modifier("start"),
        props.addonAfter && bem.modifier("end"),
      ])}
    >
      <InputNumberAntd {...props} status={props["aria-invalid"] ? "error" : undefined} />
    </div>
  );
};
